import { Launch24 } from '@carbon/icons-react';
import styled from 'styled-components';

type Props = {
  to: string;
  text: string;
};

export const ExternalTextLinkWithIcon = (props: Props) => {
  return (
    <Container>
      <Link href={props.to} target="blank">
        {props.text}
      </Link>
      <Icon />
    </Container>
  );
};

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  &:hover {
    filter: brightness(120%);
  }
`;

const Link = styled.a`
  all: unset;
  cursor: pointer;
  position: relative;
  margin-right: 5px;
  :after {
    content: '';
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 1px;
    border-width: 0 0 1px;
    border-style: solid;
  }
`;

const Icon = styled(Launch24)`
  height: 16px;
  width: 16px;
`;
